import { SpacingWrapper } from '@/shared/theme/styled-components'
import { EmptyText, ScriptContent } from './styled-components'

interface SalesScriptContentProps {
  content: string
  isEmpty: boolean
  emptyText: string
}

const SalesScriptContent = ({ content, isEmpty, emptyText }: SalesScriptContentProps) => (
  <SpacingWrapper $marginTop='1rem'>
    <ScriptContent hidden={isEmpty} dangerouslySetInnerHTML={{ __html: content }} />
    <EmptyText hidden={!isEmpty}>{emptyText}</EmptyText>
  </SpacingWrapper>
)

export default SalesScriptContent
